const environment = {
  SOURCE_URL: process.env.GATSBY_CONTENT_SOURCE || ``,
}

export default environment
